module.exports = __webpack_public_path__ + "static/media/33-iveco.fc5d3677.jpg";